import * as React from 'react';

/**
 * `false` на SSR и при первом клиентском рендере (разметка совпадает с серверной, гидрация не расходится),
 * `true` после монтирования. Нужен, чтобы откладывать тяжёлые ресурсы (фоны баннеров, логотипы),
 * которые не должны конкурировать с LCP-картинкой за канал на первых секундах загрузки.
 */
export function useIsMounted(): boolean {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
}
